module.exports = __webpack_public_path__ + "img/Group 6852@2x.529f59a0.png";